import type {
  Application,
  TriggerDescription,
} from "@smartsuite/automation-engine-api";
import {
  Display_DisplayAlways,
  Display_ShowRequiredStatus,
  ValueDescription_T,
} from "@smartsuite/automation-engine-api";
import { INPUT_APPLICATION_ID } from "../../../../utils/constants";

export const buildInitialTriggerDescription = (
  trigger: TriggerDescription,
  applications: Application[],
): TriggerDescription => ({
  ...trigger,
  inputs: [
    {
      inputId: INPUT_APPLICATION_ID,
      label: "App",
      icon: "",
      subLabel: "",
      value: {
        type: ValueDescription_T.STRING,
        multiple: false,
      },
      display: {
        display: {
          oneofKind: "always",
          always: Display_DisplayAlways.ALWAYS,
        },
        showRequiredStatus: Display_ShowRequiredStatus.REQUIRED,
      },
      editor: {
        editor: {
          oneofKind: "select",
          select: {
            options: applications.map((application) => ({
              value: application.id,
              label: application.label,
              color: "",
            })),
            multiple: false,
          },
        },
        validation: {
          oneofKind: undefined,
        },
        required: true,
      },
      dynamic: true,
    },
  ],
});
